export default __webpack_public_path__ + "static/media/330_store01-nl-mobile.b4b962d3.png";